module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "z-check",
    class: {
      'has-error': _vm.error && _vm.error.length,
      'is-dirty': _vm.isDirty,
      'disabled': _vm.$props.disabled
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.valModel),
      expression: "valModel"
    }],
    attrs: {
      "type": "checkbox",
      "id": _vm.$props.id,
      "name": _vm.$props.name,
      "disabled": _vm.$props.disabled
    },
    domProps: {
      "value": _vm.val,
      "checked": Array.isArray(_vm.valModel) ? _vm._i(_vm.valModel, _vm.val) > -1 : (_vm.valModel)
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.toggleCheck($event)
      },
      "change": function($event) {
        var $$a = _vm.valModel,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.val,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.valModel = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.valModel = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.valModel = $$c
        }
      }
    }
  }), _c('label', {
    attrs: {
      "for": _vm.$props.id
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$props.label)
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.toggleCheck($event)
      }
    }
  }), (_vm.error) ? _c('span', {
    staticClass: "z-error"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53247f20","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ZCheck.vue
// module id = 1142
// module chunks = 0